// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2p8uM","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2X7Su","obliqueLine":"membershipbadge_obliqueLine__10aEP"};